import { Component } from "react";
import "./ContactForm.css";
import Analytics from "../../utils/analytics";

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      message: "",
      isSubmitting: false,
      submitStatus: null, // null, 'success', 'error'
      errors: {}
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      errors: { ...this.state.errors, [name]: null }
    });
  };

  validateForm = () => {
    const { name, email, message } = this.state;
    const errors = {};

    if (!name.trim()) {
      errors.name = "Name is required";
    }

    if (!email.trim()) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = "Please enter a valid email address";
    }

    if (!message.trim()) {
      errors.message = "Message is required";
    }

    return errors;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.setState({ isSubmitting: true, submitStatus: null });

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: this.state.name,
          email: this.state.email,
          message: this.state.message
        })
      });

      const result = await response.json();

      if (response.ok) {
        // Track successful contact form submission
        Analytics.trackContactSubmit();
        this.setState({
          name: "",
          email: "",
          message: "",
          submitStatus: 'success',
          errors: {}
        });
      } else {
        this.setState({
          submitStatus: 'error',
          errors: result.missing || {}
        });
      }
    } catch (error) {
      console.error('Contact form error:', error);
      this.setState({
        submitStatus: 'error'
      });
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    const { name, email, message, isSubmitting, submitStatus, errors } = this.state;

    return (
      <div className="contact-form-container">
        
        {submitStatus === 'success' && (
          <div className="contact-form-success">
            ✅ Message sent successfully! I'll get back to you soon.
          </div>
        )}

        {submitStatus === 'error' && (
          <div className="contact-form-error">
            ❌ Failed to send message. Please try again.
          </div>
        )}

        <form onSubmit={this.handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name" className="form-label">
              Name *
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={this.handleInputChange}
              className={`form-input ${errors.name ? 'error' : ''}`}
              placeholder="Your name"
              disabled={isSubmitting}
            />
            {errors.name && <span className="error-message">{errors.name}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email *
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={this.handleInputChange}
              className={`form-input ${errors.email ? 'error' : ''}`}
              placeholder="your.email@example.com"
              disabled={isSubmitting}
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="message" className="form-label">
              Message *
            </label>
            <textarea
              id="message"
              name="message"
              value={message}
              onChange={this.handleInputChange}
              className={`form-textarea ${errors.message ? 'error' : ''}`}
              placeholder="Your message..."
              rows="5"
              disabled={isSubmitting}
            />
            {errors.message && <span className="error-message">{errors.message}</span>}
          </div>

          <button
            type="submit"
            className={`submit-button ${isSubmitting ? 'submitting' : ''}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    );
  }
}

export default ContactForm;
